export enum UpdateFormFieldType {
  Date = "date",
  Boolean = "boolean",
  TextWithSuffix = "textWithSuffix",
  TextArray = "TextArray",
  Text = "text",
}
